import {jsx} from 'panel';

import {BannerEl} from 'common/components/banner';
import {BannerSize, BannerTheme, BannerType} from 'common/components/banner/types';

export function AuthBanners({success, info, error}: Partial<{success: string; info: string; error: string}>) {
  if (!success && !info && !error) {
    return null;
  }
  return (
    <div sel='.mp-auth-banner-container'>
      {success && (
        <BannerEl
          attrs={{
            id: `${BannerTheme.Success}-banner`,
            theme: BannerTheme.Success,
            size: BannerSize.Small,
            type: BannerType.Embedded,
            'body-text': success,
          }}
        />
      )}
      {info && (
        <BannerEl
          attrs={{
            id: `${BannerTheme.Info}-banner`,
            theme: BannerTheme.Info,
            size: BannerSize.Medium,
            type: BannerType.Embedded,
            'body-text': info,
          }}
        />
      )}
      {error && (
        <BannerEl
          attrs={{
            id: `${BannerTheme.Error}-banner`,
            theme: BannerTheme.Error,
            size: BannerSize.Medium,
            type: BannerType.Embedded,
            'body-text': error,
          }}
        />
      )}
    </div>
  );
}
